import React, { Component } from 'react';
import './app.css';

import Header from './header';
import MenuBar from './menuBar';
import ListApps from './listApps';

const APPS = [
  {
    id: 1,
    nome: "memoriZ - Super Carros",
    descricao: "Passe todas as fases e encontre o limite da sua memória e tente explorar cada vez mais.",
    classe: "jogo",
    img: "/img/logos-apps/memoriZ.png",
    link: "http://bit.ly/App1de52"
  },
  {
    id: 2,
    nome: "Thinkers100",
    descricao: "Entre no mundo dos mais variados pensadores e conheça frases marcantes desses ilustres ícones.",
    classe: "jogo",
    img: "/img/logos-apps/thinkers100.png",
    link: "http://bit.ly/App2de52"
  },
  {
    id: 3,
    nome: "SleepWell",
    descricao: "SleepWell é a solução para aquele dia estressante, conta com um leque de diferentes tipos de áudios para relaxar o ouvinte.",
    classe: "util",
    img: "/img/logos-apps/sleepWell.png",
    link: "http://bit.ly/App3de52"
  },
  {
    id: 4,
    nome: "Reiki Time",
    descricao: "Reiki Time é um aplicativo que satisfaz a necessidade de um timer básico e útil para os praticantes do Reiki.",
    classe: "util",
    img: "/img/logos-apps/reikiTime.png",
    link: "http://bit.ly/App4de52"
  },
  {
    id: 5,
    nome: "Meditation Time",
    descricao: "Meditation Time é um aplicativo que satisfaz a necessidade de um timer básico e útil para os praticantes.",
    classe: "util",
    img: "/img/logos-apps/meditationApp.png",
    link: "http://bit.ly/App5de52"
  },
  {
    id: 6,
    nome: "Soma 50",
    descricao: "Soma 50 possui fases aleatória onde gera 3 opções para o jogador escolher quais chegam ao resultado proposto.",
    classe: "jogo",
    img: "/img/logos-apps/soma.png",
    link: "http://bit.ly/App6de52"
  },
  {
    id: 7,
    nome: "Mala Pronta",
    descricao: "Mala Pronta te ajuda a organizar os itens que vai levar na sua viagem de uma forma simples, ticando cada objeto na lista e adicionando novos. Ao completar a lista, você esta pronto para viajar.",
    classe: "util",
    img: "/img/logos-apps/malaPronta.png",
    link: "http://bit.ly/App7de52"
  },
  {
    id: 8,
    nome: "Wallpaper Super Carros",
    descricao: "Wallpaper Super Carros é um aplicativo de papel de parede com tema de super carros, basta escolher e clicar no botão.",
    classe: "util",
    img: "/img/logos-apps/superCarros.png",
    link: "http://bit.ly/App8de52"
  },
  {
    id: 9,
    nome: "KFinanceiro",
    descricao: "KFinanceiro ajuda a gerenciar suas finanças mês a mês, sabendo que dinheiro está entrando ou saindo e com o que esta gastando, incluindo as datas. Verifique meses anteriores e posteriores, afim de gerenciar todo seu dinheiro.",
    classe: "util",
    img: "/img/logos-apps/kfinanceiro.png",
    link: "http://bit.ly/App9de52"
  }
];

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      select: 'jogo',
      apps: APPS
    }

    this.changeClasse = (tipo) => {
      console.log(tipo)
      this.setState({select: tipo});
    }
  }

  render() {
    const apps = this.state.apps.slice().filter( (app) => this.state.select === app.classe );
    //console.log(apps)
    return (
      <div className="App">
        <Header />
        <MenuBar changeClasse={this.changeClasse} />
        <ListApps select={this.state.select} apps={apps} />
        <footer className="footer">
          @Todos os direitos reservados. React Games BR.
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js